/**
 * Google Maps configuration for the whole app.
 *
 * The key is a build-time env var (CRA inlines `REACT_APP_*` at build), so it
 * ships in the bundle like every browser Maps key does. That is expected — a
 * Maps JS key is not a secret — but it MUST be restricted in Google Cloud
 * Console by HTTP referrer (localhost:3001 + the deployed origin) and to the
 * "Maps JavaScript API", or anyone can bill your project. See README.
 */
export const GOOGLE_MAPS_API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";

export const hasGoogleMapsKey = GOOGLE_MAPS_API_KEY.length > 0;

/**
 * Optional Cloud-based map style ID. Nothing here requires one — markers are
 * drawn with symbol icons rather than Advanced Markers precisely so the app
 * works with a bare API key — but setting it applies a styled basemap from the
 * Google Cloud console.
 */
export const GOOGLE_MAPS_MAP_ID =
  process.env.REACT_APP_GOOGLE_MAPS_MAP_ID || undefined;

/**
 * Metres per screen pixel at a given latitude and zoom — the Web Mercator
 * ground resolution. Needed because Maps stroke weights are in pixels but the
 * mowing swath is a real-world width, so it has to be re-derived on every zoom.
 */
export function metersPerPixel(latitude: number, zoom: number): number {
  return (
    (40075016.686 * Math.abs(Math.cos((latitude * Math.PI) / 180))) /
    Math.pow(2, zoom + 8)
  );
}
